/**
 * Every screen that downloads when first opened (React Router `lazy`). After the first screen shows, the
 * rest are fetched in the background (`prefetchPages`), so moving between pages doesn't wait for a download.
 */
export const PAGES = {
  auditLog: () => import("@/features/audit-log/AuditLogPage"),
  brandDetail: () => import("@/features/brands/BrandDetailPage"),
  brands: () => import("@/features/brands/BrandsPage"),
  dispatchMessages: () => import("@/features/dispatch-messages/DispatchMessagesPage"),
  disputes: () => import("@/features/disputes/DisputesPage"),
  ledger: () => import("@/features/ledger/LedgerPage"),
  paymentDetail: () => import("@/features/payments/PaymentDetailPage"),
  payments: () => import("@/features/payments/PaymentsPage"),
  payoutDetail: () => import("@/features/payouts/PayoutDetailPage"),
  payouts: () => import("@/features/payouts/PayoutsPage"),
  plans: () => import("@/features/plans/PlansPage"),
  promoCodes: () => import("@/features/promo-codes/PromoCodesPage"),
  reconciliation: () => import("@/features/reconciliation/ReconciliationPage"),
  reviews: () => import("@/features/reviews/ReviewsPage"),
  settings: () => import("@/features/settings/SettingsPage"),
  newFreePlan: () => import("@/features/subscriptions/NewFreePlanPage"),
  subscriptionDetail: () => import("@/features/subscriptions/SubscriptionDetailPage"),
  subscriptions: () => import("@/features/subscriptions/SubscriptionsPage"),
  userDetail: () => import("@/features/users/UserDetailPage"),
  users: () => import("@/features/users/UsersPage"),
} as const;

/** Fetches every screen's code while the browser is idle (once; later calls reuse the same downloads). */
export function prefetchPages(): void {
  const load = () => Object.values(PAGES).forEach((page) => void page().catch(() => undefined));
  if ("requestIdleCallback" in window) window.requestIdleCallback(load, { timeout: 5_000 });
  else setTimeout(load, 2_000);
}
